import script from "./UsersPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersPage.vue?vue&type=script&setup=true&lang=js"

import "./UsersPage.vue?vue&type=style&index=0&id=b52d2cda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b52d2cda"]])

export default __exports__